import { __extends } from "tslib";
import { GetTextDetectionRequest, GetTextDetectionResponse } from "../models/index";
import { deserializeAws_json1_1GetTextDetectionCommand, serializeAws_json1_1GetTextDetectionCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetTextDetectionCommand = /** @class */ (function (_super) {
    __extends(GetTextDetectionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetTextDetectionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetTextDetectionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetTextDetectionRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetTextDetectionResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetTextDetectionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1GetTextDetectionCommand(input, context);
    };
    GetTextDetectionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1GetTextDetectionCommand(output, context);
    };
    return GetTextDetectionCommand;
}($Command));
export { GetTextDetectionCommand };
//# sourceMappingURL=GetTextDetectionCommand.js.map